import { cn } from "core/lib/utils"

export default function Progress({ fg, bg, progress }: any) {
  return (
    <div className={cn("h-[3px] w-[71px] rounded-[42px]", bg)}>
      <div className={cn("h-full", fg)} style={{ width: `${progress}%` }}></div>
    </div>
  )
}
